<div class="lum-c-sku-stock-details font-default">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <cnc-sku-stock-details-channel-orders
          [filters]="filters$"
        ></cnc-sku-stock-details-channel-orders>
      </div>
    </div>
  </div>
  <!-- <div class="modal-footer"></div> -->
</div>
